module.exports = {"652923001":"热斯坦街道","652923002":"萨克萨克街道","652923003":"新城街道","652923004":"东城街道","652923101":"乌恰镇","652923102":"前进镇","652923103":"齐满镇","652923104":"墩阔坦镇","652923105":"牙哈镇","652923106":"乌尊镇","652923107":"龟兹镇","652923108":"二八台镇","652923201":"玉奇吾斯塘乡","652923202":"东风乡","652923203":"红星乡","652923204":"阿克吾斯塘乡","652923205":"阿格乡","652923206":"塔里木乡","652923500":"库车经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652923.json
// module id = 3094
// module chunks = 0